// Jquery no conflict to prevent conflicts
var $ = jQuery.noConflict();